import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-dark q-pa-md text-subtitle1 text-white flex full-width justify-between" }
const _hoisted_2 = { style: {"vertical-align":"middle"} }
const _hoisted_3 = { class: "row full-width items-center" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "text-h5" }
const _hoisted_7 = { class: "text-subtitle1" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "row full-width items-center" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "row full-width items-center" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "text-subtitle1" }
const _hoisted_15 = { class: "row full-width items-center" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-subtitle1" }
const _hoisted_19 = { class: "text-subtitle3" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "row full-width items-center" }
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "text-subtitle1" }
const _hoisted_25 = { class: "text-subtitle3" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "row full-width items-center" }
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "text-subtitle1" }
const _hoisted_31 = { class: "text-subtitle3" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "row full-width items-center" }
const _hoisted_34 = { class: "col-6 text-overline text-uppercase" }
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "text-subtitle1" }
const _hoisted_38 = { class: "text-subtitle3" }
const _hoisted_39 = { key: 1 }

import { PropType } from "vue";
import { FinanceCompanies } from "src/const/finance-companies";
import { useCurrencyFormatter } from "src/functions";
import { HpPrice, PcpPrice } from "src/types/loan-application/index";
import TableRow from "src/types/shared/table-row";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteCard',
  props: {
    row: {
      type: Object as PropType<TableRow>,
      default: null
    }
  },
  emits: ['view', 'convert', 'underwriting', 'proceed'],
  setup(__props, { emit: __emit }) {

const props = __props

  function logo(id: number) {
    const l = FinanceCompanies.find(f => f.financeCompanyId === id);
    if (!l) {
      return "";
    }
    return require(`assets/logos/${l.logo}`)
  }

  const emit = __emit
  function view() {
    emit('view', props.row)
  }
  function convert() {
    emit('convert', props.row)
  }
  function underwriting() {
    emit('underwriting', props.row)
  }
  function proceedClick() {
    emit('proceed', props.row)
  }

return (_ctx: any,_cache: any) => {
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(props.row.term) + " months (" + _toDisplayString(props.row.pcp ? 'PCP' : 'HP') + ")", 1),
      _createVNode(_component_q_btn, {
        round: "",
        flat: "",
        dense: "",
        class: "q-ml-sm",
        size: "sm",
        icon: "mdi-dots-vertical",
        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","stop"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { bordered: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, { separator: "" }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        clickable: "",
                        class: "flex items-center",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (view()))
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("View Quote Details")
                        ])),
                        _: 1,
                        __: [5]
                      })), [
                        [_directive_close_popup]
                      ]),
                      (props.row.isQuickQuote)
                        ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            key: 0,
                            clickable: "",
                            class: "flex items-center",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (convert()))
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode("Convert to proposal")
                            ])),
                            _: 1,
                            __: [6]
                          })), [
                            [_directive_close_popup]
                          ])
                        : (__props.row.state === 0 && __props.row.prime)
                          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              key: 1,
                              clickable: "",
                              class: "flex items-center",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (underwriting()))
                            }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("Underwriting")
                              ])),
                              _: 1,
                              __: [7]
                            })), [
                              [_directive_close_popup]
                            ])
                          : _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              key: 2,
                              clickable: "",
                              class: "flex items-center",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (proceedClick()))
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("Proceed")
                              ])),
                              _: 1,
                              __: [8]
                            })), [
                              [_directive_close_popup]
                            ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_q_list, { separator: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, { class: "full-width" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-6 text-overline text-uppercase" }, " Per Month ", -1)),
              _createElementVNode("div", _hoisted_4, [
                (props.row.ppm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(useCurrencyFormatter)(props.row.ppm, 2, 2).split('.')[0]), 1),
                      _createElementVNode("span", _hoisted_7, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.ppm, 2, 2).split('.')[1]), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_q_icon, { name: "mdi-minus" })
                    ]))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, { class: "full-width" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-6 text-overline text-uppercase" }, " Lender ", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: logo(props.row.lender),
                  style: {"height":"40px"}
                }, null, 8, _hoisted_11)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, { class: "full-width" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-6 text-overline text-uppercase" }, " APR ", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(props.row.apr) + "%", 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, { class: "full-width" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-6 text-overline text-uppercase" }, " Deposit ", -1)),
              _createElementVNode("div", _hoisted_16, [
                (props.row.deposit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(useCurrencyFormatter)(props.row.deposit, 2, 2).split('.')[0]), 1),
                      _createElementVNode("span", _hoisted_19, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.deposit, 2, 2).split('.')[1]), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_q_icon, { name: "mdi-minus" })
                    ]))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, { class: "full-width" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-6 text-overline text-uppercase" }, " Part Ex. ", -1)),
              _createElementVNode("div", _hoisted_22, [
                (props.row.px)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(useCurrencyFormatter)(props.row.px, 2, 2).split('.')[0]), 1),
                      _createElementVNode("span", _hoisted_25, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.px, 2, 2).split('.')[1]), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createVNode(_component_q_icon, { name: "mdi-minus" })
                    ]))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, { class: "full-width" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-6 text-overline text-uppercase" }, " Total Payable ", -1)),
              _createElementVNode("div", _hoisted_28, [
                (props.row.totalPayable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(useCurrencyFormatter)(props.row.totalPayable, 2, 2).split('.')[0]), 1),
                      _createElementVNode("span", _hoisted_31, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.totalPayable, 2, 2).split('.')[1]), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createVNode(_component_q_icon, { name: "mdi-minus" })
                    ]))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, { class: "full-width" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, _toDisplayString(props.row.pcp ? 'Optional ' : '') + " Final Payment ", 1),
              _createElementVNode("div", _hoisted_35, [
                (props.row.residual)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(useCurrencyFormatter)(props.row.residual, 2, 2).split('.')[0]), 1),
                      _createElementVNode("span", _hoisted_38, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.residual, 2, 2).split('.')[1]), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createVNode(_component_q_icon, { name: "mdi-minus" })
                    ]))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})